var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { useFeatureContext } from '@veeam/core';
import { DialogActions, ACTION_VIEW } from "../Dialog";
import { createUIElement } from "../helpers";
export var DialogWizardActions = createUIElement('DialogWizardActions', function (_a, ref) {
    var className = _a.className, loading = _a.loading, prev = _a.prev, next = _a.next, skip = _a.skip, done = _a.done, cancel = _a.cancel, onClick = _a.onClick, onMouseDown = _a.onMouseDown, onMouseUp = _a.onMouseUp, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onKeyPress = _a.onKeyPress, style = _a.style, rest = __rest(_a, ["className", "loading", "prev", "next", "skip", "done", "cancel", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    var t = useFeatureContext().t;
    return (React.createElement(DialogActions, __assign({}, rest, { "data-selector-id": rest['data-selector-id'] || 'dialog-wizard-actions', className: "vm-DialogWizardActions " + className, loading: loading, primary: [
            !prev.disabled && {
                id: 'prev',
                text: prev.text || t('wizard|actions|previous') || 'Previous',
                view: ACTION_VIEW.alternate,
                onClick: prev.didSelect
            },
            !next.disabled && {
                id: 'next',
                text: next.text || t('wizard|actions|next') || 'Next',
                view: ACTION_VIEW.primary,
                onClick: next.didSelect
            },
            !skip.disabled && {
                id: 'skip',
                text: skip.text || t('wizard|actions|skip') || 'Skip',
                view: ACTION_VIEW.primary,
                onClick: skip.didSelect
            },
            !done.disabled && {
                id: 'done',
                text: done.text || t('wizard|actions|done') || 'Finish',
                view: ACTION_VIEW.primary,
                onClick: done.didSelect
            },
            {
                id: 'cancel',
                text: cancel.text || t('wizard|actions|cancel') || 'Cancel',
                view: 'secondary',
                onClick: cancel.didSelect
            }
        ].filter(Boolean), onClick: onClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style })));
});
//# sourceMappingURL=DialogWizardActions.js.map